import React, { Component, useState, useEffect, useRef } from "react";
import logo from "../Assets/img/logo.png";
import { NavLink } from "react-router-dom";
import Resume from "../Assets/kb-resume2.pdf";

class Navigation extends Component {
  render() {
    return <StickyHeader />;
  }
}

function StickyHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const headerRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!headerRef.current) return;
    const observer = new ResizeObserver(() => {
      setHeaderHeight(headerRef.current.offsetHeight);
    });
    observer.observe(headerRef.current);
    return () => observer.disconnect();
  }, []);

  const closeMenu = () => setMenuOpen(false);
  const closeMenuAndReset = () => {
    setMenuOpen(false);
    window.scrollTo(0, 0);
  };

  return (
    <div
      ref={headerRef}
      className={`header${scrolled ? " header--scrolled" : ""}${menuOpen ? " header--open" : ""}`}
    >
      <div className="container">
        <div className="row middle-xs">
          <div className="col-xs-6 col-sm-2">
            <Logo />
          </div>
          <div className="col-xs-6 col-sm-10 header-nav-col">
            <button
              className={`hamburger${menuOpen ? " hamburger--open" : ""}`}
              onClick={() => setMenuOpen((o) => !o)}
              aria-label="Toggle menu"
            >
              <span />
              <span />
              <span />
            </button>
            <Nav onLinkClick={closeMenu} onNavClick={closeMenuAndReset} menuTop={headerHeight} />
          </div>
        </div>
      </div>
    </div>
  );
}

function Logo(props) {
  return (
    <div className="header-logo">
      <a href="/" style={{ border: 0 }}>
        <img src={logo} alt="" height="60" />
      </a>
    </div>
  );
}

const routes = [
  { to: "/#work", label: "Work", anchor: true },
  { to: "/design-snippets", label: "Design Snippets" },
  { to: "/about", label: "About" },
  // { to: Resume, label: "Resume", external: true },
];

const Nav = ({ onLinkClick, onNavClick, menuTop }) => {
  const links = routes.map(({ to, label, external, anchor }) => {
    if (external) {
      return (
        <a
          href={to}
          target="_blank"
          rel="noopener noreferrer"
          key={label}
          onClick={onNavClick}
        >
          <li>{label}</li>
        </a>
      );
    }

    if (anchor) {
      return (
        <a href={to} key={label} onClick={onLinkClick}>
          <li>{label}</li>
        </a>
      );
    }

    return (
      <NavLink exact to={to} key={to} onClick={onNavClick}>
        <li>{label}</li>
      </NavLink>
    );
  });

  return (
    <div
      className="header-nav"
      style={menuTop ? { "--menu-top": `${menuTop}px` } : undefined}
    >
      {links}
    </div>
  );
};

export default Navigation;
